import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q1/2022economics/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getVoteList = (type: any, page: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      awards: type,
      page,
    },
  });
};
const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
const getNews = (page: any, classId: any) => {
  return http.get(`/v1/news/topicList?page=${page}&classId=${classId}`);
};

const getRules = (type: any) => {
  const data: any = {
    1: `<p>2021年，在以习近平同志为核心的党中央坚强领导下，全市上下认真贯彻党中央决策部署，统筹疫情防控和经济社会发展，扎实抓好“六稳”、“六保”工作，奋力推进改革发展稳定各项任务，实现了“十四五”良好开局。</p>
<p>为学习贯彻党的十九届六中全会精神和中央经济工作会议精神，贯彻落实习近平总书记对重庆提出的重要指示要求，发挥党报集团主流媒体舆论引导作用，持续激发市场主体活力，弘扬企业家精神，重报集团继续携手两江新区管委会共同主办2021“十大重庆经济年度人物”“十大两江新区经济年度人物”评选活动。</p>
<p>本次评选将着力展现重庆立足新发展阶段、贯彻新发展理念、融入新发展格局、推动高质量发展取得的新成就，挖掘、宣传在深入实施以大数据智能化为引领的创新驱动发展战略行动计划，坚持做实做强做优实体经济，加快传统产业转型升级，培育战略性新兴产业发展壮大等方面做出积极贡献和显著成绩的领军人物和优秀案例。通过评选，为推动重庆高质量发展、纵深推进成渝地区双城经济圈建设等营造良好舆论氛围，以实际行动迎接党的二十大胜利召开。</p>`,
    2: `<p>（一）指导单位</p>
<p>重庆市委组织部、重庆市委宣传部、重庆市委统战部</p>
<p>（二）主办单位</p>
<p>重庆日报报业集团、重庆两江新区管委会</p>
<p>（三）组委会成员单位</p>
<p>重庆市发展改革委、重庆市科技局、重庆市经济信息委、重庆市人力社保局、重庆市规划自然资源局、重庆市住房城乡建委、重庆市城市管理局、重庆市交通局、重庆市农业农村委、重庆市商务委、重庆市文化旅游委、重庆市国资委、重庆市金融监管局、重庆市大数据发展局、重庆市工商联</p>
<p>（四）承办单位</p>
<p>上游新闻、两江新区党工委宣传部</p>
<p>（五）媒体单位</p>
<p>重庆日报、华龙网、重庆晚报、重庆晨报、重庆商报、两江新区融媒体中心</p>`,
    3: `
<p>（一）人物类</p>
<p>2021十大重庆经济年度人物</p>
<p>2021十大重庆经济年度创新人物</p>
<p>2021十大两江新区经济年度人物</p>
<p>（二）案例类</p>
<p>2021重庆经济改革创新案例</p><p>2021成渝地区协同发展创新案例</p>`,
    4: `<p><strong>1.人物类</strong></p>
<p>（1）基本要求</p>
<p>① 参评人遵守国家法律，坚持正确政治方向，践行社会主义核心价值观，具有良好的职业道德和行业声誉；</p>
<p>② 参评人在爱国、创新、诚信、社会责任和国际视野等方面不断提升自己，推动企业发挥更大作用实现更大发展；</p>
<p>③ 参评人及所在单位无不良会计信用、纳税信用和银行信用记录及其他违规违法行为，所在单位近三年内无重大安全、质量、环境污染事故发生；</p>
<p>④ 参评人在同一单位担任董事长、总裁或总经理等主要领导职务2年以上；</p>
<p>⑤“十大重庆经济年度人物”奖项和“十大重庆经济年度创新人物”奖项不得重复报名。</p>
<p>（2）奖项要求</p>
<p>①“十大重庆经济年度人物”参评人所在单位是在重庆注册的法人企业并开展业务，企业成立时间3年以上，须达到中大型企业规模，近三年保持盈利，在创造产值、税收贡献、扩大就业、行业引领、产业升级等方面有突出表现；</p>
<p>②“十大重庆经济年度创新人物”参评人所在单位是在重庆注册的法人企业并开展业务，企业成立时间2年以上，企业规模为中小型企业或小微企业，在模式创新、技术创新、产品创新、营销创新、服务创新等方面有突出表现；</p>
<p>③“十大两江新区经济年度人物”参评人所在单位是在两江新区注册的法人企业并开展业务，企业成立时间2年以上，在创造产值、税收贡献、扩大就业、行业引领、产业升级等方面在两江新区及重庆细分行业中有突出表现。</p>
<p><strong>2.案例类</strong></p>
<p>（1）2021重庆经济改革创新案例</p>
<p>加快推动重庆高质量发展中，推进重要领域和关键环节改革创新突破、落地见效，聚焦国资国企改革、民营企业改革、农业农村改革、财政金融改革、营商环境创新，以及产业升级、科技创新、人才发展、城市管理、生态文明建设等方面涌现出的可复制推广的新机制、新模式、新成果，政府或企业均可报名参评。</p>
<p>（2）2021成渝地区协同发展创新案例</p>
<p>加快推动成渝地区双城经济圈建设中，在构建双城经济圈发展新格局、合力建设现代基础设施网络、协同建设现代产业体系、共建具有全国影响力的科技创新中心、打造具有巴蜀特色的国际消费目的地、共筑长江上游生态屏障、联手打造内陆改革开放高地、共同推动城乡融合发展、强化公共服务共建共享等方面涌现出的新机制、新模式、新成果，政府或企业均可报名参评。</p>`,
    5: `<p><strong>1.经济贡献力</strong></p>
<p>参评人所在单位在营业收入、税金缴纳、带动就业等方面做出的积极贡献，在同行业中处于平均水平以上。</p>
<p>其中，“十大重庆经济年度人物”参评人所在单位在重庆地区2021年主营收入5亿元以上，纳税金额3000万元以上，就业人数300人以上，实现增加值1亿元以上。</p>
<p>“十大重庆经济年度创新人物”参评人所在单位在重庆地区2021年营业收入2000万元以上。年度研发经费投入不低于100万元，研发经费投入强度不低于5%，农业、文旅、商贸、餐饮等行业中的商业模式创新企业，可适当放宽研发经费投入条件。</p>
<p>“十大两江新区经济年度人物”参评人所在单位在重庆地区2021年营业收入1亿元以上，纳税金额500万元以上，就业人数100人以上，实现增加值2000万元以上。</p>
<p><strong>2.创新变革力</strong></p>
<p>参评人所在单位在推动科技创新与制度创新“双轮驱动”方面进行了积极探索和实践，特别是在科技创新、科技成果转化应用等方面做出创造性的改变。</p>
<p>在生产组织、产品技术、市场营销、制度管理等方面做出了颠覆性的创新，在推动产业链与创新链深度融合、数字经济与实体经济深度融合上起到引领作用。</p>
<p><strong>3.行业带动力</strong></p>
<p>参评人及所在单位参与制定国家和行业标准，产生有较大行业影响力和带动力的项目，推动行业内及跨行业的协同管理、业务优化和智能服务，为行业发展产生积极地推动和指引作用。</p>
<p><strong>4.持续发展力</strong></p>
<p>参评人及所在单位在前瞻性、战略规划、组织结构、人才资源、财务管理、企业文化等方面，建立有长效发展激励机制，在竞争中确保基业长青，推动经济社会持续发展。</p>
<p><strong>5.公益影响力</strong></p>
<p>参评人及所在单位在乡村振兴、节能减排、生态环保、公益慈善等方面，积极践行社会责任，为低碳绿色发展做出重要贡献。</p>`,
    6: `<p><strong>1． 推荐报名</strong></p>
<p>（1）定向推荐</p>
<p style="text-align: left; padding-left: 25px;">由评选活动组委会成员单位、各区县定向推荐参评。</p>
<p>（2）社会自荐</p>
<p style="text-align: left; padding-left: 25px;">符合参评条件的单位负责人自主报名参评。</p>
<p>（3）参评年限</p>
<p style="text-align: left; padding-left: 25px;">每5年（2020—2024年）为一个参评周期，5年周期内相同奖项只获评一次。</p>
<p><strong>2．入围审查</strong></p>
<p>评选活动组委会办公室依据参评信息，报相关单位进行入围资格审查，并实地考察参评人及所在单位，确定入围名单。</p>
<p><strong>3．公众点赞</strong></p>
<p>评选活动在上游新闻开设专题页面，展示人物风采，社会大众可为参评人进行网络点赞。</p>
<p><strong>4．专家评审</strong></p>
<p>由市人大代表、市政协委员、市级监管部门成员、高校专家组成专家评审会，评审提出获奖建议名单。</p>
<p><strong>5．审定发布</strong></p>
<p>根据专家评审会提出的建议，由评选活动组委会审定最终获奖名单。名单将通过媒体公示，接受社会监督。</p>
<p><strong>6．表彰颁奖</strong></p>
<p>举办“第二届成渝地区双城经济圈协同创新发展峰会暨2021十大重庆经济年度人物评选颁奖典礼”活动。</p>`,
  };
  return data[type];
};
// 人物
const vote = (page: number, search: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_vote/controller.php?enews=vote-list&search=${search}&page=${page}`,
  );
};
// 案例
const caseVote = (page: number, search: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_case_vote/controller.php?enews=vote-list&search=${search}&page=${page}`,
  );
};
const voteDetail = (id: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_vote/controller.php?enews=detail&id=${id}`,
  );
};
const caseDetail = (id: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_case_vote/controller.php?enews=detail&id=${id}`,
  );
};
export {
  getBaseInfo,
  getVoteList,
  getRules,
  getDetail,
  getNews,
  vote,
  caseVote,
  voteDetail,
  caseDetail,
};
